import type { ReactNode } from "react";

export type StatusTone =
  | "neutral"
  | "positive"
  | "warning"
  | "blocking"
  | "pending"
  | "live"
  | "degraded";

export interface StatusBadgeProps {
  tone: StatusTone;
  children: ReactNode;
}

export const StatusBadge = ({ tone, children }: StatusBadgeProps) => (
  <span className={`lc-status lc-status--${tone}`}>{children}</span>
);
